// src/pages/LeadsHeader.jsx
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { useParams, Link } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const LeadsHeader = () => {
  // Eğer paramtreniz farklı adlandırıldıysa, önce o anahtarı okuyup testId’ye eşitliyoruz:
  const params = useParams();
  const testId     = params.testId ?? params.id;
  const categoryId = params.categoryId;

  const [myPermissions, setMyPermissions] = useState([]);

  const lang = useUserLanguage();
  const { translations: trans } = useTranslations(lang);
  const t = (key, def) => trans[key] || def;

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/my-permissions`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setMyPermissions(Array.isArray(data.permissions) ? data.permissions : []);
      } catch {
        setMyPermissions([]);
      }
    })();
  }, []);

  const adminPerm = myPermissions.find(p => p.module_key === "static_admin_account");
  const canCreate = adminPerm?.create_permission || adminPerm?.full_access;


  const createUrl = categoryId
    ? `/test/${testId}/category/${categoryId}/score/create`
    : `/test/score/${testId}/create`;

  return (
    <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
      <Link to={createUrl} className="btn btn-primary">
        <FiPlus size={16} className="me-2" />
        {t("ROLE_CREATE_TITLE", "Oluştur")}
      </Link>
    </div>
  );
};

export default LeadsHeader;
